import dataModelGetBulletinConfig from 'models/dataModelGetBulletinConfig.json';
import dataModelQueryList from 'models/dataModelQueryList.json';
import dataModelBulletinConfigPost from 'models/dataModelBulletinConfigPost.json';
import dataModelBulletin from 'models/dataModelBulletin.json';
import dataModelConfigAutoBulletin from 'models/dataModelConfigAutoBulletin.json';
import dataModelTags from 'models/dataModelTags.json';
import dataModelInstagramComments from 'models/dataModelInstagramComments.json';
import dataModelTelegramPost from 'models/dataModelTelegramPost.json';
import dataModelBulletinContent from 'models/dataModelBulletinContent.json';
import dataModelResourceTags from 'models/dataModelResourceTags.json';
import dataModelAlarmList from 'models/dataModelAlarmList.json';
import dataModelComparison from 'models/dataModelComparison.json';
import { magicNumbers } from 'utils';
import { store } from 'store';

export const apis = (key, { get, add, update, remove, patch }) => {
  const wantTagContent = store.getState().settingsReducer.filters.public
    .wantTagContent?.selectedValue
    ? 1
    : 0;

  const apiList = [
    {
      key: 'newsPost',
      name: 'پست های خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/posts',
        count: 10,
        page: 1,
        want_tag_content: wantTagContent,
        source: 'both',
      },
      method: get,
    },
    {
      key: 'newspaperPost',
      name: 'پست های روزنامه',
      path: '/search/api/v1/search',
      params: {
        api_path: '/newspaper/posts',
        count: 10,
        page: 1,
        want_tag_content: wantTagContent,
      },
      method: get,
    },
    {
      key: 'kioskPost',
      name: 'پست های کیوسک',
      path: '/search/api/v1/search',
      params: {
        api_path: '/newspaper/kiosk',
      },
      method: get,
    },
    {
      key: 'twitterPost',
      name: 'پست های توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/posts',
        count: 10,
        page: 1,
        want_tag_content: wantTagContent,
        source: 'original',
      },
      method: get,
    },
    {
      key: 'instagramPost',
      name: 'پست های اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/posts',
        count: 10,
        page: 1,
        want_tag_content: wantTagContent,
      },
      method: get,
    },
    {
      key: 'newspaperAgencies',
      name: 'تگ‌های منبع روزنامه',
      path: '/search/api/v1/search',
      params: {
        count: 100,
        api_path: '/newspaper/agencies',
      },
      method: get,
    },
    {
      key: 'kioskBookmark',
      name: 'بوک مارک کیوسک',
      path: '/search/api/v1/kiosk/newspaper/bookmark',
      params: {
        action: 'add',
        id: 'irannewspaper.ir',
      },
      method: add,
    },
    {
      key: 'telegramPost',
      name: 'پست های تلگرام',
      path: '/search/api/v1/search',
      dataModel: dataModelTelegramPost,
      params: {
        api_path: '/telegram/posts',
        count: 10,
        page: 1,
        want_tag_content: wantTagContent,
        source: 'both',
      },
      method: get,
    },
    {
      key: 'telegramComment',
      name: 'کامنت های تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/comments',
        count: 10,
        page: 1,
      },
      method: get,
    },
    {
      key: 'instagramStory',
      name: 'استوری های اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/stories',
        count: 6,
        page: 1,
        want_tag_content: wantTagContent,
      },
      method: get,
    },
    {
      key: 'instagramComment',
      name: 'کامنت های اینستاگرام',
      path: '/search/api/v1/search',
      dataModel: dataModelInstagramComments,
      params: {
        api_path: '/instagram/comments',
        count: 10,
        page: 1,
        want_tag_content: wantTagContent,
      },
      method: get,
    },
    {
      key: 'instagramCommentByPost',
      name: 'کامنت‌های زیر پست های مرتبط با موضوع اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'bulletinConfigPost',
      name: 'ارسال تنظیمات بولتن',
      path: '/bulletin/config',
      dataModeld: dataModelBulletinConfigPost,
      method: add,
      noTest: true,
    },
    {
      key: 'getBulletinConfig',
      name: 'دریافت تنظیمات بولتن',
      path: '/bulletin/config',
      dataModel: dataModelGetBulletinConfig,
      params: {
        count: 10,
        page: 1,
      },
      method: get,
    },
    {
      key: 'bulletinAdd',
      name: 'ساخت بولتن جدید',
      path: '/bulletin/v2',
      params: {
        title: 'test-auto',
      },
      method: add,
    },
    {
      key: 'bulletinAddById',
      name: 'ارسال محتوا به بولتن',
      path: '/bulletin/content',
      params: {
        bulletin_ids: ['299'],
        platform: 'news',
        post_ids: ['parsfootball.com_696d50f0cb56c1c6212190b2f28f6b11'],
      },
      method: add,
    },
    {
      key: 'bulletinList',
      name: 'لیست بولتن ها',
      path: '/bulletin',
      params: {
        is_archive: 0,
        get_independent_total: 1,
        per_page: 10,
        page: 1,
      },
      dataModel: dataModelBulletin,
      method: get,
    },
    {
      key: 'bulletinRemove',
      name: 'حذف بولتن',
      path: '/bulletin/:id',
      method: remove,
      noTest: true,
    },
    {
      key: 'bulletinEdit',
      name: 'ویرایش بولتن',
      path: '/bulletin/:id',
      method: patch,
      noTest: true,
    },
    {
      key: 'bulletinArchive',
      name: 'آرشیو کردن بولتن',
      path: '/bulletin/archive/',
      params: {
        bulletin_ids: [],
        is_archive: 1,
      },
      method: patch,
      noTest: true,
    },
    {
      key: 'bulletinUnArchive',
      name: 'فعال سازی بولتن',
      path: '/bulletin/archive/',
      params: {
        bulletin_ids: [],
        is_archive: 0,
      },
      method: patch,
      noTest: true,
    },
    {
      key: 'bulletinCopy',
      name: 'کپی بولتن',
      path: '/bulletin/:id/copyContent',
      params: {},
      method: add,
      noTest: true,
    },
    {
      key: 'queryList',
      name: 'دریافت لیست موضوعات',
      path: '/search/queries',
      dataModel: dataModelQueryList,
      params: {
        no_paginate: 1,
        orderBy: [{ field: 'created_at', type: 'desc' }],
        per_page: 10,
      },
      method: get,
    },
    {
      key: 'queryListById',
      name: 'دریافت لیست یک موضوع',
      path: '/search/queries/:id',
      dataModel: dataModelQueryList,
      method: get,
    },
    {
      key: 'addQuery',
      name: 'ذخیره موضوعات',
      path: '/search/queries',
      method: add,
      noTest: true,
    },
    {
      key: 'editQuery',
      name: 'ویرایش موضوعات',
      path: '/search/queries/:id',
      method: update,
      noTest: true,
    },
    {
      key: 'removeQuery',
      name: 'حذف موضوعات',
      path: '/search/queries/:id',
      method: remove,
      noTest: true,
    },
    {
      key: 'getVipResources',
      name: 'دریافت لیست منابع ویژه',
      path: '/search/vip',
      method: get,
    },
    {
      key: 'getInstagramVipResources',
      name: 'دریافت لیست منابع ویژه اینستاگرام',
      path: '/vip/instagram/api/v1/users/',
      method: get,
      params: {
        page_size: 50,
      },
    },
    {
      key: 'getTwitterVipResources',
      name: 'دریافت لیست منابع ویژه توییتر',
      path: '/vip/twitter/v1/twitter/vip/user',
      method: get,
      params: {
        page_size: 50,
      },
    },
    {
      key: 'getTelegramVipResources',
      name: 'دریافت لیست منابع ویژه تلگرام',
      path: '/vip/telegram/api/v2/channels/',
      method: get,
      params: {
        page_size: 50,
      },
    },
    {
      key: 'getTelegramGroupsVipResources',
      name: 'دریافت لیست منابع ویژه',
      path: '/search/vip',
      method: get,
      params: {
        resource_type: 'telegramgroups',
      },
    },
    {
      key: 'getInstagramVipHashtags',
      name: 'لیست هشتگ اینستاگرام',
      path: '/vip/instagram/api/v1/words/',
      method: get,
    },
    {
      key: 'getTwitterVipHashtags',
      name: 'لیست هشتگ توییتر',
      path: '/vip/twitter/v1/twitter/vip/word',
      method: get,
    },
    {
      key: 'addVipResources',
      name: 'ذخیره منابع ویژه',
      path: '/search/vip',
      method: add,
    },
    {
      key: 'exactSearchTelegram',
      name: 'جست‌وجوی دقیق تلگرام',
      path: '/vip/telegram/api/v2/',
      method: add,
    },
    {
      key: 'exactSearchInstagram',
      name: 'جست‌وجوی دقیق اینستاگرام',
      path: '/vip/instagram/instagram/v1/user/',
      method: add,
    },
    {
      key: 'exactSearchTwitter',
      name: 'جست‌وجوی دقیق توییتر',
      path: '/vip/dataakcraft/twitter/v1/non_login_user/',
      method: add,
    },
    {
      key: 'addTwitterVipHashtag',
      name: 'افزودن هشتگ ویژه توییتر',
      path: '/vip/twitter/v1/twitter/vip/word',
      method: add,
      params: {},
    },
    {
      key: 'addInstagramVipHashtag',
      name: 'افزودن هشتگ ویژه اینستاگرام',
      path: '/vip/instagram/api/v1/words/',
      method: add,
      params: {},
    },
    {
      key: 'removeVipResources',
      name: 'حذف منابع ویژه',
      path: '/search/vip/:id',
      method: remove,
    },
    {
      key: 'removeVipHashtags',
      name: 'حذف هشتگ ویژه',
      path: '/search/vip/hashtag/:id',
      method: remove,
    },
    {
      key: 'getIntagramUserVipResources',
      name: ' دریافت ظرفیت منابع ویژه کاربر اینستاگرام',
      path: '/vip/instagram/api/v1/users/vip-limit',
      method: get,
    },
    {
      key: 'getTelegramUserVipResources',
      name: ' دریافت ظرفیت منابع ویژه کاربر تلگرام',
      path: '/vip/telegram/api/v2/channels/vip-limit',
      method: get,
    },
    {
      key: 'getTwitterUserVipResources',
      name: ' دریافت ظرفیت منابع ویژه کاربر توییتر',
      path: '/vip/twitter/v1/twitter/vip/user/vip-limit',
      method: get,
    },

    {
      key: 'convertInstagramIdToUsername',
      name: 'تبدیل آیدی اینستاگرام به نام کاربری اینستاگرام',
      path: '/search/vip/instagram-username',
      method: get,
    },
    {
      key: 'getUserVipAccess',
      name: 'لیست دسترسی کاربر به منابع ویژه',
      path: '/search/vip/access',
      method: get,
    },
    {
      key: 'addVipAccess',
      name: 'ذخیره دسترسی منابع ویژه کاربر',
      path: '/search/vip/access',
      method: add,
    },
    {
      key: 'updateVipAccess',
      name: 'ویرایش دسترسی منابع ویژه کاربر',
      path: '/search/vip/access/:id',
      method: update,
    },
    {
      key: 'getUserInfo',
      name: 'دریافت اطلاعات کاربر',
      path: '/user',
      method: get,
    },
    {
      key: 'bulletinSmartConfig',
      name: 'دریافت اطلاعات کانفیگ',
      path: '/bulletin/smart/config',
      dataModel: dataModelConfigAutoBulletin,
      params: {
        api_path: '/bulletin/smart/config/',
      },
      method: get,
    },
    {
      key: 'bulletinSmartGetHash',
      name: 'دریافت هش مربوط به بولتن خودکار',
      path: '/bulletin/smart/config/share-hash',
      method: add,
    },
    {
      key: 'bulletinSmartHashList',
      name: 'دریافت لیست بولتن های مربوط به این بولتن خودکار',
      path: '/bulletin/v2/export/smart/:hash',
      method: get,
    },
    {
      key: 'bulletinSmartHashDetails',
      name: 'دریافت اطلاعات بولتن مورد نظر',
      path: '/bulletin/v2/export/smart/:hash/:id',
      method: get,
    },
    {
      key: 'bulletinSmartConfigAdd',
      name: 'ایجاد اطلاعات کانفیگ',
      path: '/bulletin/smart/config',
      params: {
        title: 'test_auto',
        suffix_type: 'number',
      },
      method: add,
    },
    {
      key: 'bulletinSmartConfigEdit',
      name: 'آپدیت اطلاعات کانفیگ',
      path: '/bulletin/smart/config',
      method: update,
      noTest: true,
    },
    {
      key: 'bulletinSmartConfigToggle',
      name: 'برای فعال/غیرفعال کردن کانفیک بولتن',
      path: '/bulletin/smart/config/toggle-active',
      method: add,
    },
    {
      key: 'bulletinContentPlatforms',
      name: 'دریافت لیست پلتفرم‌های یک بولتن',
      path: '/bulletin/:id',
      dataModel: dataModelBulletinContent,
      method: get,
      testId: 233,
    },
    {
      key: 'bulletinContent',
      name: 'دریافت لیست محتوای یک بولتن',
      path: '/bulletin/:id/content',
      method: get,
      params: {
        platform: ['news'],
      },
      testId: 233,
    },
    {
      key: 'bulletinContentRemove',
      name: 'حذف محتوا از یک بولتن',
      path: '/bulletin/:id/content',
      method: remove,
      noTest: true,
    },
    {
      key: 'bulletinContentSort',
      name: 'مرتب کردن محتوا در یک بولتن',
      path: '/bulletin/:id/sorts',
      params: {
        platform: 'news',
        sort_type: 'manual',
      },
      method: add,
      testId: 233,
    },
    {
      key: 'addTag',
      name: 'ذخیره کردن دسته‌بندی تگ‌ها',
      path: '/dynamic_index_analyzer/api/v2/tagCategory',
      params: { title: 'test_auto', tags: ['test_auto_1', 'test_auto_2'] },
      method: add,
    },
    {
      key: 'editTag',
      name: 'ویرایش کردن دسته‌بندی تگ‌ها',
      path: '/dynamic_index_analyzer/api/v2/tagCategory/:id',
      params: {
        title: 'test_auto_update',
        newTags: ['test_auto_update_1', 'test_auto_update_2'],
      },
      method: update,
      testId: 35,
    },
    {
      key: 'getTags',
      name: 'دریافت لیست دسته‌بندی تگ‌ها',
      path: '/dynamic_index_analyzer/api/v1/tagCategory',
      dataModel: dataModelTags,
      method: get,
      params: {
        per_page: 10,
        with: ['tags'],
        sort: ['created_at,desc'],
      },
    },
    {
      key: 'removeTags',
      name: 'حذف دسته‌بندی تگ‌ها',
      path: '/dynamic_index_analyzer/api/v1/tagCategory/:id',
      method: remove,
      noTest: true,
    },
    {
      key: 'taggedContent',
      name: 'اعمال تگ‌ها به محتوا',
      path: '/dynamic_index_analyzer/api/v1/taggedContent/multi',
      method: patch,
      noTest: true,
    },
    {
      key: 'taggedContentV2',
      name: 'اعمال تگ‌ها به محتوا',
      path: '/dynamic_index_analyzer/api/v2/taggedContent/multi',
      method: patch,
      noTest: true,
    },
    {
      key: 'loginCaptcha',
      name: 'دریافت کد کپچا',
      path: '/user/captcha/api/flat',
      method: get,
    },
    {
      key: 'updateUserInfo',
      name: 'ویرایش اطلاعات کاربر',
      path: '/user/:id/updateOnboardStatus',
      method: add,
      noTest: true,
    },
    {
      key: 'login',
      name: 'ورود در سامانه',
      path: '/user/login',
      method: add,
      noTest: true,
    },
    {
      key: 'forgotPassword',
      name: 'فراموشی رمز عبور در سامانه',
      path: '/user/forget-password',
      method: add,
      noTest: true,
    },
    {
      key: 'register',
      name: 'ثبت نام در سامانه',
      path: '/user/registerWithMobileNumber',
      method: add,
      noTest: true,
    },
    {
      key: 'checkMobileCode',
      name: 'چک کردن کد احرازهویت ثبت نام',
      path: '/user/checkMobileCode',
      method: add,
      noTest: true,
    },
    {
      key: 'sendMobileCode',
      name: 'ارسال مجدد کد احرازهویت ثبت نام',
      path: '/user/sendMobileCode',
      method: add,
      noTest: true,
    },
    {
      key: 'sendRecoveryCode',
      name: 'ارسال مجدد کد احرازهویت ثبت نام',
      path: '/user/send-recovery-code',
      method: add,
      noTest: true,
    },
    {
      key: 'recoverPassword',
      name: 'ارسال مجدد کد احرازهویت ثبت نام',
      path: '/user/recover-password',
      method: add,
      noTest: true,
    },
    {
      key: 'logout',
      name: 'خروج از سامانه',
      path: '/user/logout',
      method: add,
      noTest: true,
    },
    {
      key: 'user-settings',
      name: 'تنظیمات کاربر',
      path: '/user/settings',
      method: add,
      noTest: true,
    },
    {
      key: 'user-password',
      name: 'تغییر رمز عبور',
      path: '/user/password',
      method: update,
      noTest: true,
    },
    // -----------------------------------------خبر
    {
      key: 'newsInfo',
      name: 'دریافت اطلاعات کلی - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'newsPostsPublishProcess',
      name: 'نمودار روند انتشار محتوا - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/posts/publish_process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'newsSubjects',
      name: 'ابر کلمات و هشتگ - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/subjects',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        type: 'text', // "hashtag", "text"
      },
      method: get,
    },
    {
      key: 'newsAgenciesBySubject',
      name: 'منابع پرنفوذ - براساس تعداد بازنشر - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/agencies/by_subject',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 8,
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'newsAgencies',
      name: 'منابع - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/agencies',
        count: 10,
      },
      method: get,
    },
    {
      key: 'newsPostsCategoryChart',
      name: 'دسته بندی محتوا - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/posts/category/chart',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
      },
      method: get,
    },
    {
      key: 'newsAgenciesGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'newsUsersHistory',
      name: 'روند رشد اعضا - خبر',
      path: '/search',
      params: {
        api_path: '/news/{id}/history',
        count: 10,
      },
      method: get,
      noTest: true,
    },
    {
      key: 'newsUsersAvatarHistory',
      name: 'هیستوری تصویر آواتار - خبر',
      path: '/search',
      params: {
        api_path: '/news/{id}/avatar_history',
        count: 10,
      },
      method: get,
      noTest: true,
    },
    {
      key: 'newsPostSentiment',
      name: 'نمودار جهت‌گیری - خبر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    // ---------------------------------------------روزنامه
    {
      key: 'newspaperInfo',
      name: 'دریافت اطلاعات کلی - روزنامه',
      path: '/search/api/v1/search',
      params: {
        api_path: '/newspaper/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    // ---------------------------------------------اینستاگرام
    {
      key: 'instagramInfo',
      name: 'دریافت اطلاعات کلی - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'instagramPostsPublishProcess',
      name: 'نمودار روند انتشار محتوا - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/posts/share_process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'instagramBatchPublishProcess',
      name: 'نمودار 5 هشتگ برتر - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/batch/publish/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        type: 'hashtag',
      },
      method: get,
    },
    {
      key: 'instagramSubjects',
      name: 'ابر کلمات و هشتگ - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/subjects',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        type: 'hashtag', // "hashtag", "text"
      },
      method: get,
    },
    {
      key: 'instagramUsersBySubject',
      name: 'منابع پرنفوذ - براساس تعداد مطالب مرتبط - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/users/by_subject',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 8,
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'instagramUsers',
      name: 'منابع - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/users',
        count: 10,
        sort: 'follower_count',
        sort_type: 'desc',
        want_vip_flag: 1,
      },
      method: get,
    },
    {
      key: 'instagramPostsGgender',
      name: 'نمودار جنسیت - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/posts/gender',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['male', 'female', 'org'],
      },
      method: get,
    },
    {
      key: 'instagramPostsAgeClassification',
      name: 'نمودار رده سنی - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/posts/age_classification',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['adult', 'old', 'young', 'teen'],
      },
      method: get,
    },
    {
      key: 'instagramCommentsSentiment',
      name: 'نمودار جهت‌گیری کامنت‌ها - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    {
      key: 'instagramPostsCategoryChart',
      name: 'دسته بندی محتوا - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/posts/category/chart',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
      },
      method: get,
    },
    {
      key: 'instagramPostsGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'instagramUsersHistory',
      name: 'روند رشد اعضا - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/users/{id}/history',
        count: 10,
      },
      method: get,
      testId: '6923060922',
    },
    {
      key: 'instagramUsersAvatarHistory',
      name: 'هیستوری تصویر آواتار - اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/users/{id}/avatar_history',
        count: 10,
      },
      method: get,
      testId: '6923060922',
    },
    //-----------------------------------------کامنت اینستاگرام
    {
      key: 'instagramCommentsInfoByComment',
      name: 'دریافت اطلاعات کلی - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'instagramCommentsInfoByPost',
      name: 'دریافت اطلاعات کلی - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'instagramCommentByPostPublishProcess',
      name: 'نمودار روند انتشار کامنت‌ها - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts/info/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'instagramCommentByCommentEmoji',
      name: 'ابر ایموجی - براساس کامنت‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/emoji',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        count: 10,
      },
      method: get,
    },
    {
      key: 'instagramCommentByPostEmoji',
      name: 'ابر ایموجی - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts/emoji',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        count: 10,
      },
      method: get,
    },
    {
      key: 'instagramCommentByPostCloud',
      name: 'ابر کلمات - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts/cloud',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
      },
      method: get,
    },
    {
      key: 'instagramCommentByCommentCloud',
      name: 'ابر کلمات - براساس کامنت‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/cloud',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
      },
      method: get,
    },
    {
      key: 'instagramCommentUsersByPostBySubject',
      name: 'منابع پرنفوذ - براساس تعداد فالوور و کامنت - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/users/by_posts/most_commented',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 8,
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'instagramCommentByPostGgender',
      name: 'نمودار جنسیت - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts/gender',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['male', 'female', 'org'],
      },
      method: get,
    },
    {
      key: 'instagramCommentByCommentGgender',
      name: 'نمودار جنسیت - براساس کامنت‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/gender',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['male', 'female', 'org'],
      },
      method: get,
    },
    {
      key: 'instagramCommentByPostAgeClassification',
      name: 'نمودار رده سنی - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts/age_classification',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['adult', 'old', 'young', 'teen'],
      },
      method: get,
    },
    {
      key: 'instagramCommentByCommentAgeClassification',
      name: 'نمودار رده سنی - براساس کامنت‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/age_classification',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['adult', 'old', 'young', 'teen'],
      },
      method: get,
    },
    {
      key: 'instagramCommentsByPostSentiment',
      name: 'نمودار جهت‌گیری کامنت‌ها - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    {
      key: 'instagramCommentsByCommentSentiment',
      name: 'نمودار جهت‌گیری کامنت‌ها - براساس کامنت‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    {
      key: 'instagramCommentByCommentGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - براساس کامنت‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'instagramCommentByPostGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - براساس پست‌های مرتبط - کامنت اینستاگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/comments/by_posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    //-----------------------------------------توییتر
    {
      key: 'twitterInfo',
      name: 'دریافت اطلاعات کلی - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'twitterPostsPublishProcess',
      name: 'نمودار روند انتشار مطلب - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/posts/tweet_process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'twitterBatchPublishProcess',
      name: 'نمودار 5 هشتگ برتر - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/batch/publish/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        type: 'hashtag',
      },
      method: get,
    },
    {
      key: 'twitterSubjects',
      name: 'ابر کلمات و هشتگ - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/subjects',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        type: 'hashtag', // "hashtag", "text"
      },
      method: get,
    },
    {
      key: 'twitterUsersBySubject',
      name: 'منابع پرنفوذ - براساس تعداد مطالب مرتبط - تعداد فالوور - تعداد منشن - تعداد بازنشر - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/users/by_subject',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 8,
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'twitterUsers',
      name: 'منابع - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/users',
        count: 10,
        sort: 'follower_count',
        sort_type: 'desc',
      },
      method: get,
    },
    {
      key: 'virastyUsers',
      name: 'منابع - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/users',
        count: 10,
        sort_type: 'desc',
      },
      method: get,
    },
    {
      key: 'linkedinUsers',
      name: 'منابع - لینکدین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/users',
        count: 10,
      },
      method: get,
    },
    {
      key: 'twitterPostsGgender',
      name: 'نمودار توزیع جنسیت - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/posts/gender',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['male', 'female', 'org'],
      },
      method: get,
    },
    {
      key: 'twitterCommentsSentiment',
      name: 'نمودار تحلیل احساسات مطالب - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    {
      key: 'twitterPostsAgeClassification',
      name: 'نمودار رده سنی - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/posts/age_classification',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['adult', 'old', 'young', 'teen'],
      },
      method: get,
      noTest: true,
    },
    {
      key: 'twitterPostsCategoryChart',
      name: 'دسته بندی محتوا - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/posts/category/chart',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
      },
      method: get,
    },
    {
      key: 'twitterPostsGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'twitterUsersHistory',
      name: 'روند رشد اعضا - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/users/{id}/history',
        count: 10,
        id: '1337031096245112832',
      },
      method: get,
      testId: '1337031096245112832',
    },
    {
      key: 'twitterUsersAvatarHistory',
      name: 'هیستوری تصویر آواتار - توییتر',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/users/{id}/avatar_history',
        count: 10,
        id: '1337031096245112832',
      },
      method: get,
      testId: '1337031096245112832',
    },
    //----------------------------------------- Virasty
    {
      key: 'virastyInfo',
      name: 'دریافت اطلاعات کلی - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // last week
      },
      method: get,
    },
    {
      key: 'virastyPostsPublishProcess',
      name: 'نمودار روند انتشار مطلب - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/posts/publish_process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // last week
      },
      method: get,
    },
    {
      key: 'virastyBatchPublishProcess',
      name: 'نمودار 5 هشتگ برتر - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/batch/publish/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // last week
        type: 'hashtag',
      },
      method: get,
    },
    {
      key: 'virastySubjects',
      name: 'ابر کلمات و هشتگ - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/subjects',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // last week
        count: 50,
        type: 'hashtag', // "hashtag", "text"
      },
      method: get,
    },
    {
      key: 'virastyUsers',
      name: 'منابع - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/users',
        count: 10,
        sort: 'follower_count',
        sort_type: 'desc',
      },
      method: get,
    },
    {
      key: 'virastyPostsCategoryChart',
      name: 'دسته بندی محتوا - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/posts/category/chart',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // last week
        count: 10,
      },
      method: get,
    },
    {
      key: 'virastyPostsSentiment',
      name: 'نمودار تحلیل احساسات مطالب - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // last week
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    {
      key: 'virastyPostsGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - ویراستی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // last week
      },
      method: get,
    },
    //-----------------------------------------تلگرام
    {
      key: 'telegramInfo',
      name: 'دریافت اطلاعات کلی - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'telegramGroupsPostsCount',
      name: 'تعداد مطالب در گروه‌های تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/groups/posts/count',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
      },
      method: get,
    },
    {
      key: 'telegramPostsPublishProcess',
      name: 'نمودار روند انتشار مطلب - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/info/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        info: 'post_count',
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'telegramChannelsHistory',
      name: 'نمودار روند رشد اعضا - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/channels/{id}/history',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        id: '9713124490',
      },
      method: get,
      testId: '9713124490',
    },
    {
      key: 'telegramBatchPublishProcess',
      name: 'نمودار 5 هشتگ برتر - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/batch/publish/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        type: 'hashtag',
      },
      method: get,
    },
    {
      key: 'telegramSubjects',
      name: 'ابر کلمات و هشتگ - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/subjects',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        type: 'hashtag', // "hashtag", "text"
      },
      method: get,
    },
    {
      key: 'telegramUsersBySubject',
      name: 'منابع پرنفوذ - براساس تعداد مطالب مرتبط - تعداد اعضا - تعداد بازدید - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/channels/by_subject',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 8,
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'telegramUsers',
      name: 'منابع - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/channels',
        count: 10,
        sort: 'member_count',
        sort_type: 'desc',
      },
      method: get,
    },
    {
      key: 'telegramChannels',
      name: 'منابع پرنفوذ - براساس تعداد نرخ بازدید - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/channels',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 8,
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'telegramPostsCategoryChart',
      name: 'دسته بندی محتوا - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/posts/category/chart',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
      },
      method: get,
    },
    {
      key: 'telegramPostsGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'telegramPostsEmoji',
      name: 'ابر ایموجی - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/posts/emoji',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        count: 10,
      },
      method: get,
    },
    {
      key: 'telegramPostSentiment',
      name: 'نمودار جهت‌گیری کامنت‌ها - تلگرام',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    {
      key: 'telegramUsersHistory',
      name: 'روند رشد اعضا - تلگرام',
      path: '/search',
      params: {
        api_path: '/telegram/channels/{id}/history',
        count: 10,
        id: '9713124490',
      },
      method: get,
      testId: '9713124490',
    },
    {
      key: 'telegramUsersAvatarHistory',
      name: 'هیستوری تصویر آواتار - تلگرام',
      path: '/search',
      params: {
        api_path: '/telegram/channels/{id}/avatar_history',
        count: 10,
      },
      method: get,
      testId: '9713124490',
    },
    //
    {
      key: 'bulletinConfig',
      name: 'دریافت تنظیمات بولتن',
      path: '/bulletin/config',
      dataModel: null,
      method: get,
    },
    {
      key: 'bulletinV2Export',
      name: 'دریافت خروجی pdf',
      path: '/bulletin/v2/export?style=gpr',
      dataModel: null,
      method: add,
      noTest: true,
    },
    {
      key: 'bulletinClassicV2Export',
      name: 'دریافت خروجی pdf',
      path: '/bulletin/v2/export?style=classic',
      dataModel: null,
      method: add,
      noTest: true,
    },
    {
      key: 'userNotifications',
      name: 'دریافت اعلان‌ها',
      path: '/user/notifications',
      dataModel: null,
      method: get,
      params: {
        paginate: 10,
      },
    },
    {
      key: 'unvisibleNotifications',
      name: 'عدم نمایش اعلان‌ها',
      path: '/user/notifications/visible',
      params: {
        visible: false,
      },
      dataModel: null,
      method: update,
    },
    {
      key: 'resourceTags',
      name: 'دریافت لیست تگ های منبع',
      path: '/search/tags',
      dataModel: dataModelResourceTags,
      method: get,
      params: {
        no_paginate: 1,
      },
    },
    {
      key: 'addResourceCategory',
      name: 'ذخیره تگ منبع',
      path: '/search/tags',
      method: add,
      noTest: true,
    },
    {
      key: 'getByplatformResourceTags',
      name: 'دریافت منابع تگ های منبع',
      path: '/search/api/v2/tags/:id/resources',
      method: get,
      params: {
        platform: 'news',
      },
      testId: '627',
    },
    {
      key: 'getByIdResourceTags',
      name: 'دریافت لیست تگ های منبع',
      path: '/search/tags/:id',
      method: get,
      testId: '627',
    },
    {
      key: 'editResourceCategory',
      name: 'ویرایش تگ های منبع',
      path: '/search/tags/:id',
      method: add,
      noTest: true,
    },
    {
      key: 'removeResourceCategory',
      name: 'حذف تگ های منبع',
      path: '/search/tags/:id',
      method: remove,
      noTest: true,
    },
    {
      key: 'versionCheck',
      name: 'دریافت تغییرات سامانه',
      path: '/dashboard/version/check',
      params: {
        type: 'gpr',
        orderBy: [
          {
            field: 'published_at',
            type: 'desc',
          },
        ],
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'versionSeen',
      name: 'دیدن تغییرات سامانه',
      path: '/dashboard/version/seen',
      dataModel: null,
      method: add,
    },
    {
      key: 'versionPublic',
      name: 'دریافت تمامی تغییرات سامانه',
      path: '/dashboard/version/public',
      params: {
        type: 'gpr',
        paginate: 0,
        orderBy: [
          {
            field: 'published_at',
            type: 'desc',
          },
        ],
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'alarmList',
      name: 'دریافت لیست آلارم‌ها',
      path: '/search/api/v1/alarm/alarms',
      dataModel: dataModelAlarmList,
      method: get,
    },
    {
      key: 'alarmContacts',
      name: 'دریافت لیست مخاطبان در آلارم‌ها',
      path: '/alarm/contacts',
      params: { verified: 1 },
      dataModel: null,
      method: get,
    },
    {
      key: 'addAlarmContacts',
      name: 'ذخیره لیست مخاطبان در آلارم‌ها',
      path: '/alarm/contacts',
      dataModel: null,
      method: add,
      noTest: true,
    },
    {
      key: 'editAlarmContacts',
      name: 'ویرایش لیست مخاطبان در آلارم‌ها',
      path: '/alarm/contacts/:id',
      dataModel: null,
      method: update,
      noTest: true,
    },
    {
      key: 'removeAlarmContacts',
      name: 'حذف لیست مخاطبان در آلارم‌ها',
      path: '/alarm/contacts/:id',
      dataModel: null,
      method: remove,
      noTest: true,
    },
    {
      key: 'checkCerificationAlarmContacts',
      name: ' Check verification code',
      path: '/alarm/contacts/check_code/:id',
      dataModel: null,
      method: remove,
      noTest: true,
    },
    {
      key: 'sendCerificationAlarmContacts',
      name: 'Send verification code again',
      path: '/alarm/contacts/send_code/:id',
      dataModel: null,
      method: remove,
      noTest: true,
    },
    {
      key: 'alarmTelegramChannels',
      name: 'دریافت لیست کانال‌های تلگرام در آلارم‌ها',
      path: '/alarm/telegram_channels',
      params: {},
      dataModel: null,
      method: get,
    },
    {
      key: 'searchApiV2AlarmTelegramBots',
      name: 'ذخیره بات تلگرام',
      path: '/search/api/v2/alarm/telegram_bots',
      dataModel: null,
      method: add,
      noTest: true,
    },
    {
      key: 'searchApiV2AlarmTelegram_channels',
      name: 'ذخیره کانال تلگرام',
      path: '/alarm/telegram_channels',
      dataModel: null,
      method: add,
      noTest: true,
    },
    {
      key: 'addAlarm',
      name: 'ذخیره آلارم',
      path: '/alarm/stories',
      method: add,
      noTest: true,
    },
    {
      key: 'editAlarm',
      name: 'ویرایش آلارم',
      path: '/alarm/stories/:id',
      method: update,
      noTest: true,
    },
    {
      key: 'removeAlarm',
      name: 'حذف آلارم',
      path: '/search/api/v1/alarm/alarms/:id',
      method: remove,
      noTest: true,
    },
    {
      key: 'alarmById',
      name: 'دریافت جزئیات یک الارم',
      path: '/alarm/stories/:id',
      dataModel: null,
      method: get,
      noTest: true,
    },
    {
      key: 'exportContentExcelV1',
      name: 'خروجی اکسل',
      path: '/search/api/v1/excels',
      dataModel: null,
      method: add,
    },
    {
      key: 'exportContentExcel',
      name: 'خروجی اکسل',
      path: '/search/excels',
      dataModel: null,
      method: add,
    },
    {
      key: 'supportRequests',
      name: 'لیست پشتیبانی',
      path: '/search/support/requests',
      dataModel: null,
      method: get,
    },
    {
      key: 'supportRequestsAdd',
      name: 'افزودن تیکت جدید پشتیبانی',
      path: '/search/support/requests',
      dataModel: null,
      method: add,
    },
    {
      key: 'supportRequestsComments',
      name: 'دریافت کامنت های یک تیکت از پشتیبانی',
      path: '/search/support/requests/:id/comments',
      dataModel: null,
      method: get,
    },
    {
      key: 'supportRequestsResolve',
      name: 'بستن یک تیکت از پشتیبانی',
      path: '/search/support/requests/:id/resolve',
      dataModel: null,
      method: add,
    },
    {
      key: 'supportRequestsAddComment',
      name: 'افزودن یک کامنت به یک تیکت از پشتیبانی',
      path: '/search/support/comments',
      dataModel: null,
      method: add,
    },
    {
      key: 'supportRequestsGetById',
      name: 'دریافت اطلاعات یک تیکت از پشتیبانی',
      path: '/search/support/requests/:id',
      dataModel: null,
      method: get,
    },
    {
      key: 'comparisonList',
      name: 'دریافت لیست مقایسه ها',
      path: '/search/comparison',
      dataModel: dataModelComparison,
      method: get,
      params: {
        per_page: 10,
        sort: ['created_at,desc'],
      },
    },
    {
      key: 'comparisonGetById',
      name: 'دریافت اطلاعات یک مقایسه',
      path: '/search/comparison/:id',
      dataModel: null,
      method: get,
    },
    {
      key: 'addComparison',
      name: 'ذخیره اطلاعات یک مقایسه',
      path: '/search/comparison',
      dataModel: null,
      method: add,
    },
    {
      key: 'comparisonUpdate',
      name: 'آپدیت اطلاعات یک مقایسه',
      path: '/search/comparison/:id',
      dataModel: null,
      method: update,
    },
    {
      key: 'removeComparison',
      name: 'حذف مقایسه',
      path: '/search/comparison/:id',
      method: remove,
      noTest: true,
    },
    //----------------------------- nativePlatforms
    {
      key: 'nativePlatformsUsers',
      name: 'منابع بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/channels',
        count: 10,
        sort: 'member_count',
        sort_type: 'desc',
      },
      method: get,
    },
    {
      key: 'nativePlatformsInfo',
      name: 'دریافت اطلاعات کلی - بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'nativePlatformsPostsPublishProcess',
      name: 'نمودار روند انتشار مطلب - بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/info/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        info: 'post_count',
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'nativePlatformsBatchPublishProcess',
      name: 'نمودار 5 هشتگ برتر - بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/batch/publish/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        type: 'hashtag',
      },
      method: get,
    },
    {
      key: 'nativePlatformsSubjects',
      name: 'ابر کلمات و هشتگ - بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/subjects',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        type: 'hashtag', // "hashtag", "text"
      },
      method: get,
    },
    {
      key: 'nativePlatformsPostsCategoryChart',
      name: 'دسته بندی محتوا - بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/posts/category/chart',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
      },
      method: get,
    },
    {
      key: 'nativePlatformsPostsGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'nativePlatformsPostSentiment',
      name: 'نمودار جهت‌گیری کامنت‌ها - بسترهای داخلی',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    //----------------------------- comparison
    {
      key: 'comparisionSubjectInfo',
      name: 'دریافت اطلاعات کلی - مقایسه موضوع',
      path: '/search/api/v1/comparison/compare',
      params: {
        api_path: 'info',
        platforms: ['instagram', 'telegram', 'twitter', 'news'],
        queries: [],
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'comparisionSubjectPublishProcess',
      name: 'دریافت  روند انتشار محتوا  - مقایسه موضوع',
      path: '/search/api/v1/comparison/compare',
      params: {
        api_path: 'info/process',
        platforms: ['instagram', 'telegram', 'twitter', 'news'],
        queries: [],
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        time_gap: 'hour',
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'comparisionSubjectSubjectsText',
      name: 'دریافت  ابر کلمات  - مقایسه موضوع',
      path: '/search/api/v1/comparison/compare',
      params: {
        api_path: 'subjects',
        platforms: ['instagram', 'telegram', 'twitter', 'news'],
        queries: [],
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        type: 'text',
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'comparisionSubjectSubjectsHashtag',
      name: 'دریافت  ابر هشتگ  - مقایسه موضوع',
      path: '/search/api/v1/comparison/compare',
      params: {
        api_path: 'subjects',
        platforms: ['instagram', 'telegram', 'twitter'],
        queries: [],
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        type: 'hashtag',
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'comparisionSubjectSentiment',
      name: 'دریافت جهت گیری مطالب(همه به جز خبر) - مقایسه موضوع',
      path: '/search/api/v1/comparison/sentiment',
      params: {
        platforms: ['instagram', 'telegram', 'twitter'],
        queries: [],
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'comparisionSubjectGender',
      name: 'دریافت جنسیت(فقط اینستا و تویتر)  - مقایسه موضوع',
      path: '/search/api/v1/comparison/gender',
      params: {
        platforms: ['instagram', 'twitter'],
        queries: [],
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      dataModel: null,
      method: get,
    },
    {
      key: 'resourceCategoryOffer',
      name: 'دسته بندی های پیشنهادی',
      path: '/search/tags/recommended',
      method: get,
    },
    // ---------------------------------------------لینکدین
    {
      key: 'linkedinInfo',
      name: 'دریافت اطلاعات کلی - لینکدین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/info',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'linkedinPostsPublishProcess',
      name: 'نمودار روند انتشار محتوا - لینکدین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/info/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
    {
      key: 'linkedinSubjects',
      name: 'ابر کلمات و هشتگ - لینکدین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/subjects',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 50,
        type: 'hashtag', // "hashtag", "text"
      },
      method: get,
    },
    {
      key: 'linkedinBatchPublishProcess',
      name: 'نمودار 5 هشتگ برتر - لیندکین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/batch/publish/process',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        type: 'hashtag',
      },
      method: get,
    },
    {
      key: 'linkedinUsersBySubject',
      name: 'منابع پرنفوذ - براساس تعداد مطالب مرتبط - لینکدین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/users/by_subject',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 8,
        sort_type: 'DESC',
      },
      method: get,
    },
    {
      key: 'linkedinPostsSentiment',
      name: 'نمودار جهت‌گیری پست ها - لینکدین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/posts/sentiment',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
        fields: ['negative', 'positive', 'neutral'],
      },
      method: get,
    },
    {
      key: 'linkedinPostsCategoryChart',
      name: 'دسته بندی محتوا - لیندکین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/posts/category/chart',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
        count: 10,
      },
      method: get,
    },
    {
      key: 'linkedinPostsGeoHeatMap',
      name: 'نقشه هیت مپ جغرافیایی - لینکدین',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/posts/geo',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS, // یک هفته گذشته
      },
      method: get,
    },
  ];
  if (key) {
    return apiList.find((item) => item.key === key);
  }
  return apiList;
};
